<template>
  <v-container fluid class="pa-0 ma-0" id="contact">
    <PageHeader> SEND A PAYMENT </PageHeader>

    <p class="font-weight-light text-center subtitle pt-15">Case Study</p>
    <UnderLinedHeader
      class="white"
      :class="!$vuetify.breakpoint.smAndDown ? 'px-16' : 'mx-2'"
    >
      For Your Business
    </UnderLinedHeader>
    <p class="text-center mt-6">
      Please click the link below to remit payment.
    </p>
    <a href="https://secure.lawpay.com/pages/3545consulting/operating-cts">
      <v-img
        class="mx-auto"
        alt="lawpay-pay-invoice-btn"
        max-width="350"
        :src="
          require('@/assets/imgs/Clients/lawpay-pay-invoice-btn-350x130.png')
        "
        :lazy-src="
          require('@/assets/imgs/Clients/lawpay-pay-invoice-btn-350x130.png')
        "
      ></v-img>
    </a>
    <ContactMap></ContactMap>
  </v-container>
</template>

<script>
import PageHeader from "@/components/global/compnentsMixins/PageHeader.vue";
import UnderLinedHeader from "@/components/global/compnentsMixins/UnderLinedHeader.vue";
import ContactMap from "@/components/contact/ContactMap.vue";
export default {
  components: { PageHeader, UnderLinedHeader, ContactMap },
};
</script>

<style lang="scss" scoped>
</style>